import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

import { MenuNewEquipment } from '../components/megamenu-new/models/new-equipment.model';
import { MenuUsedEquipment } from '../components/megamenu-used/models/used-equipment.model';
import { MenuSpareParts } from '../components/megamenu-spare/models/spare.model';
import { MenuCustomerService } from '../components/megamenu-customer-service/model/customer-service.model';
import { MenuDigitalSolutionsResults } from '../components/megamenu-digital-solutions/model/digital-solutions.model';

@Injectable({
  providedIn: 'root',
})
export class HeadService {
  private http = inject(HttpClient);
  private readonly apiUrl: string;
  private readonly headers = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  constructor() {
    this.apiUrl = environment.apiURL;
  }

  getCategoriesWithSubcategoriesNewEquipment(): Observable<MenuNewEquipment[]> {
    return this.http.get<MenuNewEquipment[]>(
      `${this.apiUrl}categories-with-subcategories/`,
      this.headers
    );
  }

  getCategoriesWithSubcategoriesUsedEquipment(): Observable<MenuUsedEquipment[]> {
    return this.http.get<MenuUsedEquipment[]>(
      `${this.apiUrl}used-equipment-categories/`,
      this.headers
    );
  }

  getCategoriesWithSubcategoriesSpareParts(): Observable<MenuSpareParts[]> {
    return this.http.get<MenuSpareParts[]>(
      `${this.apiUrl}parts-categories-with-subcategories/`,
      this.headers
    );
  }

  getCategoriesCustomerService(): Observable<MenuCustomerService[]> {
    return this.http.get<MenuCustomerService[]>(
      `${this.apiUrl}outstanding-services/?ordering=order`,
      this.headers
    );
  }

  getCategoriesDigitalSolutions(): Observable<MenuDigitalSolutionsResults> {
    return this.http.get<MenuDigitalSolutionsResults>(
      `${this.apiUrl}solutions/?ordering=order`,
      this.headers
    );
  }
}
